/**
 * PROVISIONING-FLOW-FRONTEND-1 — helpers PUROS do fluxo de provisionamento do
 * InstallerPortal (Cliente × Infraestrutura/Torre). Extraídos p/ teste em node.
 */

/** Passos dinâmicos do wizard por tipo. Infra NÃO passa por Cliente/Template
 *  (sem IXC). */
export function stepsFor(deploymentType) {
  return deploymentType === "infrastructure"
    ? ["equipment", "type", "infra", "finish"]
    : ["equipment", "type", "customer", "template", "finish"];
}

/** Detecta o IXC restrito: 401 (sem auth) OU 403 (autenticado mas sem permissão,
 *  ex.: técnico field — IXC é platform-only). Mensagem amigável, sem reabrir IXC. */
export function isIxcProtected(err) {
  if (!err) return false;
  if (err.status === 401 || err.status === 403) return true;
  return /authentication required|protegid|unauthor|forbidden|permiss/i.test(
    String(err.message || "")
  );
}

/** Mensagem amigável p/ o IXC restrito, conforme o usuário esteja logado. */
export function ixcRestrictedMessage(loggedIn) {
  return loggedIn
    ? "Busca IXC ainda restrita. Use Infraestrutura/Torre ou peça liberação via NOC."
    : "Busca IXC protegida. Entre pelo NOC ou use o fluxo de Infraestrutura/Torre.";
}

/** Monta o bloco `provisioning` da Infra para gravar em
 *  installation_sessions.raw_json.provisioning. Coordenada só vai se válida;
 *  origem 'manual' quando o técnico edita lat/lng à mão. */
export function buildInfraProvisioning({
  operationalIdentifier,
  hardwareCapability,
  category,
  displayName,
  notes,
  lat,
  lng,
  accuracyM,
  locationSource,
} = {}) {
  const hasCoord =
    lat !== "" && lat != null && lng !== "" && lng != null &&
    !Number.isNaN(Number(lat)) && !Number.isNaN(Number(lng));
  return {
    deployment_type: "infrastructure",
    hardware_capability: hardwareCapability || "core",
    operational_identifier: (operationalIdentifier || "").trim(),
    category: category || null,
    display_name: (displayName || "").trim() || null,
    notes: (notes || "").trim() || null,
    location: hasCoord
      ? {
          lat: Number(lat),
          lng: Number(lng),
          accuracy_m: accuracyM != null ? Number(accuracyM) : null,
          location_source: locationSource || "manual",
        }
      : null,
  };
}
